export default class AwaitedPropertyTimeoutException extends Error {
    constructor(propertyName, totalWaitTime) {
        const message = `Failed while awaiting property '${propertyName}' for ${totalWaitTime}ms`;
        super(message);
    }
}
